module.exports = __webpack_public_path__ + "img/razzo4.a979cefb.webp";